import {Calibrator} from "./types";
import {WinpharmaCalibrator} from "./WinpharmaCalibrator";
import {LGPICalibrator} from "./LGPICalibrator";

/**
 * LGO ids supporting web-side autocalibration.
 * Values mirror the main process `LGO` enum.
 */
export const CALIBRATABLE_LGO = {
    LGPI: 11,
    WINPHARMA: 21,
} as const;

/**
 * Get the calibrator for a given LGO.
 *
 * @param lgoId The LGO id, as returned in the `detection:capture` meta.
 * @returns The calibrator, or null when the LGO has no autocalibration support.
 */
export function calibratorForLgo(lgoId: number): Calibrator | null {
    switch (lgoId) {
        case CALIBRATABLE_LGO.WINPHARMA:
            return new WinpharmaCalibrator();
        case CALIBRATABLE_LGO.LGPI:
            return new LGPICalibrator();
        default:
            return null;
    }
}

export * from "./types";
